import { defineStore } from "pinia";
import api from "../api/axios";
import router from "@/routers/index.js";
import { Login, GetCode } from "../api/axios";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    user: null,
    token: localStorage.getItem("token") || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
  },

  actions: {
    async login(phone, code) {
      try {
        const { data } = await Login({ phone, code });
        this.token = data.token;

        localStorage.setItem("token", data.token);
        await this.fetchUser();
      } catch (err) {
        console.error("Ошибка authStore login:", err.response?.data || err);
        throw err;
      }
    },

    async getCode(phone, code) {
      try {
        const { data } = await GetCode({ phone, code });
      } catch (err) {
        console.error("Ошибка getCode:", err.response?.data || err);
        throw err;
      }
    },

    async fetchUser() {
      const { data } = await api.get("/account/profile", {
        headers: { Authorization: this.token },
      });
      this.user = data;
    },

    logout() {
      this.user = null;
      this.token = null;
      localStorage.removeItem("token");
      router.push({ name: "Feed" });
    },
  },
});
